import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {LowerCasePipe, NgFor, NgIf} from '@angular/common';
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';
import {builtInExtractions, BuiltInSourceConfig, builtInSources, StandardPricingRow} from "../../../../../assets/data/built-in-sources";
import {standardDestinations} from "../../../../../assets/data/destinations";

@Component({
    selector: 'app-info-standard-integration',
    templateUrl: './info-standard-integration.component.html',
    styleUrls: ['./info-standard-integration.component.scss'],
    imports: [NgIf, NgFor, ModalHeaderComponent, MatDialogContent, LowerCasePipe]
})
export class InfoStandardIntegrationComponent implements OnInit {
  protected config?: BuiltInSourceConfig

  constructor(
    public dialogRef: MatDialogRef<InfoStandardIntegrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      integration: string,
      mode: 'extraction' | 'source' | 'destination',
    },
  ) { }

  ngOnInit() {
    const lists: Record<typeof this.data.mode, BuiltInSourceConfig[]> = {
      extraction: builtInExtractions,
      source: builtInSources,
      destination: standardDestinations,
    }
    this.config = lists[this.data.mode].find(
      s => s.type === this.data.integration || s.id === this.data.integration
    )
  }

  get baseRows(): StandardPricingRow[] {
    return this.config?.pricingRows?.filter(r => !r.optional) ?? []
  }

  get optionalRows(): StandardPricingRow[] {
    return this.config?.pricingRows?.filter(r => r.optional) ?? []
  }
}
